import { render, staticRenderFns } from "./MsgDetails.vue?vue&type=template&id=55740391&scoped=true"
import script from "./MsgDetails.vue?vue&type=script&lang=js"
export * from "./MsgDetails.vue?vue&type=script&lang=js"
import style0 from "./MsgDetails.vue?vue&type=style&index=0&id=55740391&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55740391",
  null
  
)

export default component.exports